// Breadcrumbs component

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { MdChevronRight } from "react-icons/md";
import { Link as RouterLink } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

/**
 * Reusable breadcrumbs component for navigation
 */
export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <Breadcrumb
      spacing="8px"
      separator={<MdChevronRight color="gray.500" />}
      mb={4}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <BreadcrumbItem key={index} isCurrentPage={isLast}>
            {item.href && !isLast ? (
              <BreadcrumbLink as={RouterLink} to={item.href}>
                {item.label}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                color={isLast ? 'gray.700' : 'brand.500'}
                fontWeight={isLast ? 'semibold' : 'normal'}
              >
                {item.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
}
